import { Form } from "antd";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import Select from "@/common/elements/InputElements/Select";
import TextField from "@/common/elements/InputElements/TextField";
import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { getOptionsFromRefList } from "@/util/common_function";
import { FieldSecurityProvider } from "@/contexts/FieldSecurityContext";
import SecureFormItem from "@/common/SecureFormItem";

const OfficerReportLocationSection = ({ report = {}, startingPoint = "" }) => {
  return (
    <FieldSecurityProvider
      entity="OffenseDetails"
      startingPoint={startingPoint}
    >
      <Form
        layout="vertical"
        initialValues={{
          facility: report.facility || "",
          block: report.block || "",
          cell: report.cell || "",
          bed: report.bed || "",
          location: report.location || "",
        }}
      >
        <StyledGridRow gutter={16} justify={'start'}>
          <StyledGridCol lg={4}>
            <SecureFormItem
              fieldName="facility"
              formItemProps={{ name: "facility", label: "Facility" }}
            >
              <TextField />
            </SecureFormItem>
          </StyledGridCol>
          <StyledGridCol lg={4}>
            <SecureFormItem
              fieldName="block"
              formItemProps={{ name: "block", label: "Block" }}
            >
              <Select
                options={getOptionsFromRefList("Block", false, false, true)}
                placeholder="Select Block"
              />
            </SecureFormItem>
          </StyledGridCol>
          <StyledGridCol lg={4}>
            <SecureFormItem
              fieldName="cell"
              formItemProps={{ name: "cell", label: "Cell" }}
            >
              <Select
                options={getOptionsFromRefList("Cell", false, false, true)}
                placeholder="Select Cell"
              />
            </SecureFormItem>
          </StyledGridCol>
          <StyledGridCol lg={4}>
            <SecureFormItem
              fieldName="bed"
              formItemProps={{ name: "bed", label: "Bed" }}
            >
              <Select
                options={getOptionsFromRefList("Bed", false, false, true)}
                placeholder="Select Bed"
              />
            </SecureFormItem>
          </StyledGridCol>
          <StyledGridCol lg={7}>
            <SecureFormItem
              fieldName="location"
              formItemProps={{ name: "location", label: "Incident Location" }}
            >
              <Select
                options={getOptionsFromRefList("IncidentLocationCode", false, false, true)}
                placeholder="Select Incident Location"
              />
            </SecureFormItem>
          </StyledGridCol>
        </StyledGridRow>
      </Form>
    </FieldSecurityProvider>
  );
};

export default OfficerReportLocationSection;
